module.exports = __webpack_public_path__ + "static/media/EmailIcon.43fb747f.svg";